import { makeStyles } from 'tss-react/mui';

import { backdropClasses } from '@mui/material';

export default makeStyles({ name: 'DrawerMenuButton' })((theme) => ({
    button: {
        display: 'flex',
        padding: 4,
        alignItems: 'center',
        borderRadius: 8,
        background: '#F8F8F8 !important',
        zIndex: theme.zIndex.drawer + 1
    },
    paper: {
        width: 296,
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    modal: {
        [`.${backdropClasses.root}`]: {
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
            backdropFilter: 'blur(8px)'
        }
    },
    menu: {
        padding: 8,
        boxShadow: '0 8px 16px 0 rgba(176, 178, 186, 0.10), 0 12px 32px 0 rgba(176, 178, 186, 0.25)'
    },
    upgrade: {
        padding: '12px 24px',
        margin: '12px 0'
    }
}));
